import util from '../util'

let controller = 'SchedulerRegBoletos'
export default {
    Get: function (id) {
        return util.Axios.Get(controller, id)
    },
    GetAll: function (dto) {
        return util.Axios.GetAll(controller, dto)
    },
    Post: function (dto) {
        return util.Axios.Post(controller, dto)
    },
    Put: function (id, dto) {
        return util.Axios.Put(controller, id, dto)
    },
    Delete: function (id) {
        return util.Axios.Delete(controller, id)
    }
}
